<template>
  <div class="user_all" v-loading="fullscreenLoading">
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.environment') }}：</span>
      <el-select style="width: 250px" v-model="selectEnv" @change="changeEnv" :placeholder="this.$t('title.environment')">
        <el-option v-for="item in optionEnv" :key="item.code" :label="item.name" :value="item.code"></el-option>
      </el-select>
      <span style="width: 100px;display: inline-block;margin-left: 30px">{{ $t('title.system') }}：</span>
      <el-select style="width: 250px" v-model="selectApp" @change="changeApp" :placeholder="this.$t('title.system')">
        <el-option
          v-for="item in optionsApp"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        ></el-option>
      </el-select>
    </div>
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.contract') }}：</span>
      <el-select
        style="width: 350px"
        v-model="selectConTem"
        :placeholder="this.$t('title.please_choose')"
        @change="changeConTem"
      >
        <el-option
          v-for="item in optionConTem"
          :key="item.userContractId"
          :label="`${item.rpcServer} - ${item.chainId}链 - ${item.contractName}`"
          :value="item.userContractId"
        ></el-option>
      </el-select>
      <span style="display: inline-block;margin-left: 30px">{{ $t('title.Contract_address') }}：</span>
      <span style="display: inline-block;margin-left: 10px">{{ConTemadds}}</span>
      <el-button
        type="primary"
        style="margin-left: 30px"
        @click="contractDetail"
        :loading="Loading"
      >详情</el-button>
    </div>
    <!-- 详情弹框 -->
    <el-dialog title="合约详情" :visible.sync="dialogVisible" width="50%">
      <el-table :data="userCollectionData" border style="width: 100%">
        <el-table-column :label="this.$t('title.address')">
          <template slot-scope="scope">
            <span>{{ scope.row.address}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.address)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="xtoCounts" label="xto个数"></el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="currentPageChange"
        :current-page="currentPage"
        :page-size="pagesize"
        layout="total,prev, pager, next"
        :total="total"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('title.Cancel') }}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{ $t('title.Sure') }}</el-button>
      </span>
    </el-dialog>
    <div class="user_search">
      <span style="display: inline-block;">{{ $t('title.CreationAddress') }}：</span>
      <span style="display: inline-block;margin-left: 10px">{{genesisAddress}}</span>
      <el-button
        type="primary"
        style="margin-left: 30px"
        @click="searchConTemNum"
        :loading="Loading"
      >{{ $t('title.search') }}</el-button>
      <span style="display: inline-block;margin-left: 30px">{{ $t('title.XTO_quantity') }}：</span>
      <span style="display: inline-block;margin-left: 10px">{{ConTemNum}}</span>
    </div>
    <div class="user_search" style="display: flex">
      <span style="width: 100px;display: inline-block">{{ $t('title.address') }}：</span>
      <el-input v-model="searchAddressNum" type="primary" style="width: 250px" :placeholder="this.$t('title.Please_enter_the_address')"></el-input>
      <el-button
        type="primary"
        style="margin-left: 30px"
        @click="searchAddNum"
        :loading="Loading"
      >{{ $t('title.search') }}</el-button>
      <span style="display: inline-block;margin-left: 30px">{{ $t('title.XTO_quantity') }}：</span>
      <span style="display: inline-block;margin-left: 10px">{{AddtNum}}</span>
    </div>
    <div class="user_search" style="border-top: 1px solid #ccc;padding-top: 10px;">
      <p style="color:red;">{{ $t('title.UserA_to_userB0') }}</p>
      <span style="width: 100px;display: inline-block">{{ $t('title.UserA') }}：</span>
      <el-select style="width: 250px" v-model="selectUserA" :placeholder="this.$t('title.please_choose')" @change="changeUserA">
        <el-option
          v-for="item in userA"
          :key="item.id"
          :label="`${item.nickname} - ${item.address}`"
          :value="item.id"
        ></el-option>
      </el-select>
      <span style="display: inline-block;margin-left:20px;">{{ $t('title.Balance') }}：</span>
      <span style="display: inline-block;margin-right:10px;">{{coinsA}}</span>
      <span style="display: inline-block;margin-left:20px;">{{ $t('title.XTO_quantity') }}：</span>
      <span style="display: inline-block;margin-right:10px;">{{xtA}}</span>
      <span style="width: 100px;display: inline-block;">{{ $t('title.UserA_address') }}：</span>
      <span style="display: inline-block;margin-right:20px">{{userAaddsA}}</span>
    </div>
    <div class="user_search" style="display:flex;align-items: center;">
      <span style="width: 100px;display: inline-block;">{{ $t('title.UserB') }}：</span>
      <div class="user_search_address">
        <el-select
          style="width: 250px"
          v-model="selectUserB"
          :placeholder="this.$t('title.please_choose')"
          @change="changeUserB"
        >
          <el-option
            v-for="item in userB"
            :key="item.id"
            :label="`${item.nickname} - ${item.address}`"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          v-model="inputUserB"
          type="primary"
          style="width: 250px;margin-top:10px;"
          :placeholder="this.$t('title.designated_address')"
        ></el-input>
      </div>
      <span style="display: inline-block;margin-left:20px;">{{ $t('title.Balance') }}：</span>
      <span style="display: inline-block;margin-right:10px;">{{coinsB}}</span>
      <span style="display: inline-block;margin-left:20px;">{{ $t('title.XTO_quantity') }}：</span>
      <span style="display: inline-block;margin-right:10px;">{{xtB}}</span>
      <span style="width: 100px;display: inline-block;">{{ $t('title.UserB_address') }}：</span>
      <span style="display: inline-block;margin:0 10px">{{userAaddsB}}</span>
    </div>
    <div class="user_search" style="border-bottom: 1px solid #ccc;padding-bottom: 10px;">
      <span style="width: 100px;display: inline-block;">{{ $t('title.XTO_quantity') }}：</span>
      <el-input
        v-model="trValue"
        type="primary"
        style="width: 150px"
        oninput="value=value.replace(/[^0-9.]/g,'')"
        :placeholder="this.$t('title.Please_enter_the_number_ofXTO')+':'"
      ></el-input>
      <el-button
        type="primary"
        style="margin-left: 30px"
        @click="transferAndOutBonus(1)"
        :loading="Loading"
      >{{ $t('title.transfer') }}</el-button>
    </div>
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.Award') }}：</span>

      <el-input v-model="inputAward" type="primary" style="width: 250px" :placeholder="this.$t('title.Please_enter_the_address')"></el-input>
      <span style="width: 70px;display: inline-block;margin-left: 30px">{{ $t('title.XTO_quantity') }}：</span>
      <el-input
        v-model="awValue"
        type="primary"
        style="width: 250px"
        oninput="value=value.replace(/[^0-9.]/g,'')"
        :placeholder="this.$t('title.Please_enter_the_number_ofXTO')+':'"
      ></el-input>
      <el-button
        type="primary"
        style="margin-left: 30px"
        @click="transferAndOutBonus(2)"
        :loading="Loading"
      >{{ $t('title.Award') }}</el-button>
    </div>
    <div class="user_search" style="float: right">
      <el-button type="primary" style="margin-left: 30px" @click="searAdd">{{ $t('title.Refresh') }}</el-button>
    </div>

    <div class="con_table">
      <el-table
        :data="tableData"
        border
        height="520"
        style="width: 100%;margin-bottom: 30px;margin-top: 40px"
        :header-cell-style="this.tableHeaderColor"
      >
        <el-table-column label="hash" width="400" align="center">
          <template slot-scope="scope">
            <el-link
              @click="$refs.searchHash.open(scope.row.hash, scope.row.rpcServer, scope.row.fromChainId)"
              :underline="false"
              type="primary"
            >{{scope.row.hash}}</el-link>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Serial_number')" fixed align="center" width="90">
          <template slot-scope="scope">
            <span>{{scope.row.id}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.RPC_service')" width="200" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.rpcServer}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Chain_id')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromChainId}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Transfer_address')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromAddress}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.fromAddress)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_before_transfer')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromBeforeCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_after_transfer')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromAfterCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Payee_address')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.toAddress}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.toAddress)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_before_payment')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.toBeforeCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_after_receipt')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.toAfterCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.XTO_quantity')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.coins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Gas_fee')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.gasFee}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Creation_time')" width="200" align="center">
          <template slot-scope="scope">
            <span>{{timestampToTime(scope.row.createTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('title.state')" fixed="right" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.status==-1? $t('title.Sent_awaiting_verification') :scope.row.status==-1? $t('title.failure') : $t('title.success') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <SearchHash ref="searchHash" />
    </div>
  </div>
</template>

<script>
import {
  getxtocount,
  userlList,
  transferList,
  creationAccount,
  signedS,
  sendAward,
  getxtocountAddress,
  getenvList,
  getappList,
  getcontractList,
  signedSend,
  getUserCollection,
} from "../../../api/interface";
import _ from "lodash";
import SearchHash from "../../SearchHash";
export default {
  name: "XTO",
  components: { SearchHash },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      isResponse: false,
      selectEnv: 0,
      seleArr: [],
      optionEnv: [],
      selectApp: 0,
      optionsApp: [],
      userA: [],
      userB: [],
      selectUserA: "",
      selectUserB: "",
      inputUserB: "",
      fullscreenLoading: false,
      Loading: false,
      ConTemNum: "",
      selectConTem: "",
      optionConTem: [],
      searchAddressNum: "",
      AddtNum: "",
      inputAward: "",
      ConTemadds: "",
      genesisAddress: "",
      xtA: "",
      coinsA: "",
      coinsB: "",
      xtB: "",
      trValue: "",
      awValue: "",
      userAaddsA: "",
      userAaddsB: "",
      dialogVisible: false,
      userCollectionData: [],
      total: 0,
      pagesize: 10,
      currentPage: 1,
    };
  },
  watch: {
    ConTemadds(val) {
      if (val) {
        this.getUsers();
      } else {
        this.userA = [];
        this.userB = [];
        this.userAaddsA = "";
        this.xtA = "";
        this.userAaddsB = "";
        this.xtB = "";
        this.selectUserA = "";
        this.selectUserB = "";
      }
    },
  },
  activated() {
    this.getUsers();
  },
  methods: {
    searAdd() {
      let data1 = {
        type: "201",
        page: 1,
        rows: 10,
      };
      transferList(data1).then((response) => {
        if (response.code == 200) {
          this.tableData = response.data.data;
          this.getUsers();
        } else {
          this.tableData = [];
        }
      });
    },
    //同步芯客

    //合约地址查询获取xto个数
    searchConTemNum() {
      this.Loading = true;
      getxtocount({ userContractId: this.selectConTem }).then((response) => {
        this.Loading = false;
        if (response.code == 200) {
          this.ConTemNum = response.data.value;
        } else {
          this.ConTemNum = 0;
          this.$message.error(response.msg);
        }
      });
    },
    //根据指定地址查询xto数量
    searchAddNum() {
      if (this.searchAddressNum == "") {
        this.$message.error(this.$t('title.Please_enter_the_address')+'!')
        return;
      }

      let data = {
        userContractId: this.selectConTem,
        address: this.searchAddressNum,
      };
      this.Loading = true;
      getxtocountAddress(data).then((response) => {
        this.Loading = false;
        if (response.code == 200) {
          this.AddtNum = response.data.value;
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    getUsers() {
      let data = {
        userContractId: this.selectConTem,
        address: "",
        page: 1,
        rows: 100000,
      };
      userlList(data).then((response) => {
        this.fullscreenLoading = false;
        if (response.code == 200) {
          //this.seleArr = response.data.data;
          this.userA = response.data.data;
          this.userB = response.data.data;
          this.changeUserA();
          this.changeUserB();
        } else {
          this.$message.error(response.msg);
        }
      });
    },

    //环境切换时
    changeEnv() {
      console.log(this.selectEnv, 111111);
      this.getcontractLists();
    },
    //系统切换时
    changeApp() {
      console.log(this.selectApp, 111111);
      this.getcontractLists();
    },
    //合约切换
    changeConTem(val) {
      this.optionConTem.forEach((v) => {
        if (v.userContractId == val) {
          this.ConTemadds = v.contractAddress;
          this.genesisAddress = v.address;
        }
      });
    },
    //用户a切换
    changeUserA() {
      this.userA.forEach((v) => {
        if (v.id == this.selectUserA) {
          this.userAaddsA = v.address;
          this.coinsA = v.coins;
          this.xtA = v.xtoCounts;
          console.log(this.xtA, 999999);
        }
      });
    },
    //用户B切换
    changeUserB() {
      this.userB.forEach((v) => {
        if (v.id == this.selectUserB) {
          this.userAaddsB = v.address;
          this.coinsB = v.coins;
          this.xtB = v.xtoCounts;
        }
      });
    },
    //初始化数据
    async getData() {
      //获取环境
      await getenvList().then((response) => {
        this.optionEnv = response.data;
        this.selectEnv = this.optionEnv[0].code;
      });
      //获取系统
      await getappList().then((response) => {
        this.optionsApp = response.data;
        this.selectApp = this.optionsApp[0].code;
      });
      //获取表格数据
      this.searAdd();
      this.getcontractLists();
    },
    //获取合约
    getcontractLists() {
      let data = {
        env: this.selectEnv,
        app: this.selectApp,
      };
      getcontractList(data).then((response) => {
        if (response.code == 200) {
          this.optionConTem = response.data;
          this.selectConTem = _.get(this.optionConTem[0], "userContractId", "");
          this.ConTemadds = _.get(this.optionConTem[0], "contractAddress", "");
          this.genesisAddress = _.get(this.optionConTem[0], "address", "");
        } else {
          this.optionConTem = [];
          this.$message.error(response.msg);
        }
      });
    },
    //获取合约集合个数
    contractDetail() {
      this.dialogVisible = true;
      this.getUserCollections();
    },
    getUserCollections() {
      const userContractId = this.selectConTem || 0;
      const data = {
        userContractId,
        page: this.currentPage,
        rows: this.pagesize,
      };
      getUserCollection(data).then((res) => {
        this.userCollectionData = res.data.data;
        this.total = res.data.total;
      });
    },
    //个数分页
    currentPageChange(e) {
      this.currentPage = e;
      this.getUserCollections();
    },
    //转账和发奖金 xto转账(传fromUserId)/发奖(不传fromUserId)
    transferAndOutBonus(type) {
      type == 1 ? this.tranfser() : this.award();
    },
    tranfser() {
      if (
        this.selectUserA == "" ||
        (this.selectUserB == "" && this.inputUserB == "")
      ) {
        this.$message.error("请选择转账人与接收人后再进行转账操作！");
        return;
      }
      if (
        !(
          this.selectUserA != this.selectUserB &&
          this.selectUserA != this.inputUserB
        )
      ) {
        this.$message.error("转账人与接收人不能为同一地址！");
        return;
      }

      if (this.inputUserB != "" && this.inputUserB.length < 42) {
        this.$message.error("请输入正确发奖人地址！");
        return;
      }
      if (this.trValue == "") {
        this.$message.error("转账金额不能为空！");
        return;
      }
      //如果输入地址就取输入的值 否则选的值  selectUserA是id  userAaddsB是地址
      const toAddress = this.inputUserB || this.userAaddsB;
      const data = {
        fromUserId: this.selectUserA,
        userContractId: this.selectConTem,
        xtoCount: Number(this.trValue),
        toAddress,
      };
      this.Loading = true;
      signedSend(data).then((response) => {
        if (response.code == 200) {
          this.$message.success("转账成功！");
          this.Loading = false;
          //获取表格数据
          this.searAdd();
        } else {
           this.$message.success(response.msg);
           this.Loading = false;
        }
      });
    },
    //发奖金
    award() {
      if (!(this.inputAward != "" && this.inputAward.length == 42)) {
        this.$message.error("请输入正确发奖人地址！");
        return;
      }
      if (this.awValue == "") {
        this.$message.error("请输入发奖金额！");
        return;
      }
      if (!this.selectConTem) {
        this.$message.error("请选择合约！");
        return;
      }

      const data = {
        userContractId: this.selectConTem,
        xtoCount: this.awValue,
        toAddress: this.inputAward,
      };
      this.Loading = true;
      signedSend(data).then((response) => {
        this.Loading = false;
        if (response.code == 200) {
          this.$message.success("发奖成功！");
          //获取表格数据
          this.searAdd();
        } else {
          this.$message.error(response.msg);
        }
      });
    },
  },
  computed: {
    iconColor() {
      const { color1, color2 } = this;

      if (color1 && color2) {
        return [color1, color2];
      } else {
        return [];
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style scoped lang="scss">
.user_all {
  padding: 20px 30px;
}

.user_search {
  margin-bottom: 30px;
  align-items: center;
  .user_search_address {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
.el-pagination {
  position: static;
  float: none;
  margin-right: 3%;
  margin-top: 20px;
  margin-bottom: 0;
}
</style>
